import { useMemo } from 'react';
import { skipToken } from '@reduxjs/toolkit/query/react';

import { useGetBuoysInBoundingBoxQuery } from 'actions/buoys';
import { setMapError, setMapLoading, setMapMessage } from 'actions/mapV2';
import useSyncValueToStore from 'hooks/useSyncValueToStore';

import useMapLocation from './useMapLocation';

const useBuoysBoundingBoxQuery = () => {
  const { boundingBox } = useMapLocation();

  const queryArg = boundingBox ? { ...boundingBox } : skipToken;

  const { data, error, isFetching, isUninitialized } = useGetBuoysInBoundingBoxQuery(queryArg, {
    // options.skip can be removed here as well
  });

  const loading = isFetching || isUninitialized;

  const buoysData = useMemo(
    () => (data?.data ? [...data.data]?.sort((a, b) => b.latitude - a.latitude) : undefined),
    [data?.data],
  );

  const hasBuoys = buoysData && buoysData?.length > 0;

  const noBuoysFound = !hasBuoys && !error && !loading;

  // If we want a message to display when no buoys are found update this to something like:
  // const message = noBuoysFound ? 'No buoys found! Try zooming out or moving map' : '';
  const message = undefined;

  useSyncValueToStore(setMapError, error);
  useSyncValueToStore(setMapLoading, loading);
  useSyncValueToStore(setMapMessage, message);
  return { buoys: buoysData, loading, error, noBuoysFound, hasBuoys };
};

export default useBuoysBoundingBoxQuery;
